import { BufferGeometry3D, Vector3 } from 'feng3d-three';
import { ConvexGeometry } from '../thirdparty/three/imports';

export class ConvexGeometry3D extends BufferGeometry3D
{
    get _geometry()
    {
        if (!this.__geometry)
        {
            this.__geometry = new ConvexGeometry(this.points);
        }

        return this.__geometry;
    }
    declare protected __geometry: ConvexGeometry;

    points?: Vector3[];
}
